import { fechaHora12 } from '../../../lib/format';
/*
 * Catálogos del buzón de casos (espejo de backend/buzon.py: si cambia allí, cambia aquí).
 * Contrato: email/claude/formularios.md → «Buzón de casos».
 */

export const ESTADOS = [
  { id: 'nuevo', nombre: 'Nuevo', abierto: true },
  { id: 'en_proceso', nombre: 'En proceso', abierto: true },
  { id: 'en_espera', nombre: 'En espera', abierto: true },
  { id: 'resuelto', nombre: 'Resuelto', abierto: false },
  { id: 'cerrado', nombre: 'Cerrado', abierto: false },
];
export const NOMBRE_ESTADO = Object.fromEntries(ESTADOS.map((e) => [e.id, e.nombre]));

export const PRIORIDADES = [
  { id: 'urgente', nombre: 'Urgente' },
  { id: 'alta', nombre: 'Alta' },
  { id: 'media', nombre: 'Media' },
  { id: 'baja', nombre: 'Baja' },
];
export const NOMBRE_PRIORIDAD = Object.fromEntries(PRIORIDADES.map((p) => [p.id, p.nombre]));

export const SENTIMIENTOS = { positivo: 'Positivo', negativo: 'Negativo', neutral: 'Neutral', mixto: 'Mixto' };

/** Vistas de la bandeja, en el orden de la barra lateral. `soloGestor` = no aplica a «mis casos». */
export const VISTAS = [
  { id: 'abiertos', nombre: 'Abiertos' },
  { id: 'mios', nombre: 'Míos y de mi equipo' },
  { id: 'sin_asignar', nombre: 'Sin asignar', soloGestor: true },
  { id: 'vencidos', nombre: 'Vencidos' },
  { id: 'no_leidos', nombre: 'No leídos' },
  { id: 'destacados', nombre: 'Destacados' },
  { id: 'cerrados', nombre: 'Resueltos y cerrados' },
  { id: 'todos', nombre: 'Todos' },
];

export const ORDENES = [
  { id: 'recientes', nombre: 'Más recientes' },
  { id: 'antiguos', nombre: 'Más antiguos' },
  { id: 'vencimiento', nombre: 'Vencen antes' },
  { id: 'prioridad', nombre: 'Prioridad' },
  { id: 'actividad', nombre: 'Última actividad' },
];

export const REGLAS_ASIGNACION = [
  { id: 'manual', nombre: 'Manual', detalle: 'Cada caso llega sin asignar (o a la persona responsable por defecto) y alguien lo reparte.' },
  { id: 'categoria', nombre: 'Por categoría', detalle: 'Cada categoría tiene su responsable. Si la categoría la decide Aurora, se asigna en cuanto la decide.' },
  { id: 'rotativa', nombre: 'Por turnos', detalle: 'Los casos se reparten por turnos entre las personas del equipo.' },
];

const MINUTO = 60 * 1000;
const HORA = 60 * MINUTO;
const DIA = 24 * HORA;

/** «hace 5 min», «ayer», «12 sep». */
export function haceCuanto(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const dif = Date.now() - d.getTime();
  if (dif < MINUTO) return 'ahora';
  if (dif < HORA) return `hace ${Math.floor(dif / MINUTO)} min`;
  if (dif < DIA) return `hace ${Math.floor(dif / HORA)} h`;
  if (dif < 2 * DIA) return 'ayer';
  if (dif < 7 * DIA) return `hace ${Math.floor(dif / DIA)} días`;
  const mismoAnio = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short', ...(mismoAnio ? {} : { year: 'numeric' }) });
}

/** Plazo: «vence en 2 días», «venció hace 3 h». */
export function textoPlazo(iso, abierto = true) {
  if (!iso) return 'Sin plazo';
  const dif = new Date(iso).getTime() - Date.now();
  const abs = Math.abs(dif);
  const cant = abs < HORA ? `${Math.max(1, Math.round(abs / MINUTO))} min`
    : abs < DIA ? `${Math.round(abs / HORA)} h`
      : `${Math.round(abs / DIA)} ${Math.round(abs / DIA) === 1 ? 'día' : 'días'}`;
  if (!abierto) return `Plazo: ${fechaCorta(iso)}`;
  return dif >= 0 ? `Vence en ${cant}` : `Venció hace ${cant}`;
}

export function fechaCorta(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function fechaHora(iso) {
  if (!iso) return '';
  return fechaHora12(iso);
}

/** Horas → «3.5 h» o «2.1 días». */
export function duracion(horas) {
  if (horas === null || horas === undefined) return '—';
  if (horas < 48) return `${horas.toLocaleString('es-MX', { maximumFractionDigits: 1 })} h`;
  return `${(horas / 24).toLocaleString('es-MX', { maximumFractionDigits: 1 })} días`;
}

export function iniciales(nombre = '') {
  const partes = String(nombre).replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean);
  return ((partes[0]?.[0] || '') + (partes[1]?.[0] || '')).toUpperCase() || '?';
}

/** `datetime-local` ↔ ISO (hora del navegador). */
export function aInputLocal(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}
export const deInputLocal = (valor) => (valor ? new Date(valor).toISOString() : null);
